module.exports = __webpack_public_path__ + "img/default_image.f9261640.png";